//@ts-ignore
import Cookies from 'js-cookie'
export const TOKEN_KEY = 'token'

export const setToken = (token: string) => {
  Cookies.set(TOKEN_KEY, token, { sameSite: 'None', secure: true })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY) // hack 方案
  if (token) {
    return token
  } else {
    return false
  }
}
